import { EnvironmentConfig } from '@/backend/extraTypes';
import { usePublicDataClient } from '@juvare/platform-sdk-react/ui/hooks';
import useSwr from 'swr';

export function useEnvironmentConfig() {
    const publicDataClient = usePublicDataClient();
    return useSwr<EnvironmentConfig>(
        '/environment-config',
        async () => await publicDataClient.publicDataGetObject<EnvironmentConfig>('environment-config'),
    );
}
